import { useMemo } from 'react'
import { preFixImgUrl } from '@/utils'

export type FeatureScreen = {
  img: string
  titleKey: string
  subKey: string
}

export type ProcessStep = {
  id: string
  /** 序号角标图（01–06） */
  numImg: string
  /** 步骤插画 */
  illustrationImg: string
  titleKey: string
  descKey: string
}

/** 序号角标：上传至 images 后与文件名一致；请按实际上线资源替换文件名 */
const STEP_NUM_FILES = [
  'd956df218970e1f0de45d67642917e04.png',
  '3115b4bcae60b16993d790dcfb123827.png',
  '9ecc6ad3da0b31ebdc42e2887425f32e.png',
  '8e1ab08dd826d1058aaac48af33abf11.png',
  '839f0c19e75a9ca5b9df8c039c504c59.png',
  '4e2e19673f06f02310915644d5f2e438.png',
] as const

/** 步骤插画：可替换为设计稿导出的 CDN 文件名 */
const STEP_ILL_FILES = [
  '90e08f7ab0ce4f187f34a1034570f815.png',
  '04836d190ccd47f4fbf4a7961444163c.png',
  '24ea7ee35337e906bce71ecff2c28e91.png',
  'db1164fed4c216a399706c486b51c960.png',
  '09ef456a3777d108895aadf9bbabb055.png',
  '446d2b8e697f332ea146506d91e0d720.png',
] as const

const STEP_TITLE_KEYS = ['6b9910dd', 'bd197f3b', '87620f33', '215d59c0', 'f7236472', 'a6c27065'] as const
const STEP_DESC_KEYS = ['69c8362a', 'eac6d89a', 'ff37782b', 'b1731c5c', '16df8f87', '7e1901f1'] as const

export type QuickLinkItem = {
  key: string
  iconImg: string
  /** 外链；null 表示暂无（如 FAQ 待定） */
  href: string | null
}

/** 底部快捷入口：与 JM 运营表一致；图标文件名可随设计替换 */
const QUICK_LINK_ROWS: readonly { key: string; iconFile: string; href: string | null }[] = [
  { key: '00a5d8ee', iconFile: 'e62cca86d301cb431507da5775a49803.png', href: 'https://www.japanmall.com/special?id=135' },
  { key: '487853f3', iconFile: '604ce17e39d715e03b02aba7b3874804.png', href: 'https://www.japanmall.com/special?id=132&storeId=17' },
  { key: '2aefc7a2', iconFile: '05e814b0f7beb684207c85db7417ec8d.png', href: 'https://www.japanmall.com/special?id=126' },
  { key: '2c7782ea', iconFile: '691e96c40a4369e0f941c4b9fdf709da.png', href: 'mailto:info.japanmall@jdxjp.net' },
]

export default () => {
  const processSteps = useMemo<ProcessStep[]>(
    () =>
      STEP_NUM_FILES.map((numFile, i) => ({
        id: String(i + 1).padStart(2, '0'),
        numImg: preFixImgUrl(numFile),
        illustrationImg: preFixImgUrl(STEP_ILL_FILES[i]),
        titleKey: STEP_TITLE_KEYS[i],
        descKey: STEP_DESC_KEYS[i],
      })),
    [],
  )

  const featureScreens = useMemo<FeatureScreen[]>(
    () => [
      {
        img: preFixImgUrl('e1d321dbfd8cdff4e2fbed7512f50d6c.png'),
        titleKey: '51d3630e',
        subKey: 'f2eaf27a',
      },
      {
        img: preFixImgUrl('ed9b0b106e38c7ae658fcda8eb59f494.png'),
        titleKey: '0e2a5ee1',
        subKey: '6fc5712f',
      },
      {
        img: preFixImgUrl('2955d7973f608e3394f2f6990c38510f.png'),
        titleKey: '0cc6122d',
        subKey: '1b1048a3',
      },
      {
        img: preFixImgUrl('479462fdf7bfd1d11ebf832d705f8f22.png'),
        titleKey: '1f343b1a',
        subKey: '9dcd152c',
      },
    ],
    [],
  )

  const quickLinks = useMemo<QuickLinkItem[]>(
    () =>
      QUICK_LINK_ROWS.map((row) => ({
        key: row.key,
        iconImg: preFixImgUrl(row.iconFile),
        href: row.href,
      })),
    [],
  )

  return { featureScreens, processSteps, quickLinks }
}
